// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

//import { licenseKey } from 'src/app/devextreme-license';

export const environment = {
  production: false,
  versionPostfix: '_debug',

  defaultCulture: 'pl',
  baseUrl: 'http://localhost:4200/',
  // apiUrl: 'https://dmapi-dev.bakk.cloud/',
  // apiUrl: "https://dmapi-demo.bakk.cloud/",
  apiUrl: 'http://localhost:12671/',
  //apiUrl: "http://localhost:3030/",
  disableSignalR: false,
  secretKey: 'secret',
  oidc_client_id: 'spa',
  authorityProvider: undefined, // 'idp:aad',
  authority: 'https://dmlogin-dev.bakk.cloud/',
  //authority: 'https://dmlogin-demo.bakk.cloud/',
  //authority: 'http://localhost:2020/',
  redirect_uri: '/auth-callback',
  post_logout_redirect_uri: '/',
  silent_redirect_uri: '/assets/html/silent-redirect.html',
  remoteEntryPrefix: 'https://stbakkdmwebcdn.z6.web.core.windows.net',
  defaultRedirect: 'user/blader/task-list',
  offlineRedirect: 'user/blader/stored-tasks',

  silentRequestTimeout: 5000,
  headerMfa: 'base-header', // ustaw undefined aby pominąć ładowanie headera
  elasticSearchAppName: undefined,
  elasticSearchUrl: 'https://elk-dev.bakk.cloud:8200/',
  devExtremeKey: undefined,
  enableServiceWorker: false /* window.origin.startsWith('http://localhost')
    ? false
    : true,*/,
  overrideTranslationUrl: undefined,

  customCssUrl: undefined /*
   'http://stbakkdmwebcdn.z6.web.core.windows.net/custom-style/custom-styles.css'
  */,

  // ── Konfiguracja MFE dla developmentu ──────────────────────────────
  mfeDevConfig: {
    // Odkomentuj moduł aby ładować go z innego źródła niż CDN.
    // Wartość = port (buduje http://localhost:{port}/remoteEntry.json)
    //        lub pełny URL remoteEntry (np. inny prefix/środowisko).

    localhostOverrides: {
      // actions: 4205,
      // actionsbrowser: 4207,
      // administration: 4211,
      // alert: 4400,
      // billings: 4273,
      // casecollections: 4251,
      // commonapps: 4253,
      // costs: 4250,
      // creditors: 4213,
      // dashboards: 4208,
      // dataintegration: 4297,
      // debtcase: 4206,
      // debtcaselist: 4204,
      // debtor: 4203,
      // exclusions: 4711,
      // ecourtactions: 4301,
      // eod: 4261,
      // eventregister: 4060,
      //letters: 4233,
      // mockups: 4212,
      // outgoingtransfers: 4448,
      // pwa: 4244,
      // subjectcollections: 4252,
      // taskqueue: 4283,
      // transfers: 4254,
      // workflows: 4214,
      // dialer: 4284,
      // big: 4285,
      // businessrulesengine: 4286,
      // pisp: 4593,
      //letterarchive: 4264,
    },

    // Włącz preload modułów z flagą preLoad=true.
    enablePreload: false,
  },

  gridConfig: {
    defaultRowHeight: 36,
    gridBottomMargin: 16,
    minGridHeight: 200,
    emptyGridContentHeight: 100,
    gridBorderHeight: 2,
    restoreMeasureDelay: 100,
    defaultRowCount: 10,
    extraRowTypes: ['detail', 'detailAdaptive', 'group', 'groupFooter'],
  },
};
